import * as actionTypes from './ActionTypes';
import axios from '../../Helpers/Axiosbase';
// import authSuccess from './Auth'

export const selectedApp = (selectedApp) => {
    localStorage.setItem('selectedApp', selectedApp);
    localStorage.removeItem('selectedComponent');
    // localStorage.setItem('allcomponent', allcomponent);
    return {
        type: actionTypes.SELECTED_APP,
        selectedApp: selectedApp,
        selectedComponent: null,
        // allcomponent: allcomponent,
    };
};

export const selectedComponent = (selectedComponent) => {
    localStorage.setItem('selectedComponent', JSON.stringify(selectedComponent));
    // localStorage.setItem('allcomponent', allcomponent);
    return {
        type: actionTypes.SELECTED_COMPONENT,
        selectedComponent: selectedComponent,
        // allcomponent: allcomponent,
    };
};

export const allComponent = (allComponent) => {
    localStorage.setItem('allcomponent', allComponent);
    return {
        type: actionTypes.GET_ALL_COMPONENT,
        allComponent: allComponent
    };
};

export const selectedEnvironment = (selectedEnvironment) => {
    localStorage.setItem('selectedEnvironment', JSON.stringify(selectedEnvironment));
    return {
        type: actionTypes.SELECTED_ENVIRONMENT,
        selectedEnvironment: selectedEnvironment
    };
};

export const selectedConfiguration = (selectedConfiguration) => {
    localStorage.setItem('selectedConfiguration', selectedConfiguration)
    return {
        type: actionTypes.SELECTED_CONFIGURATION,
        selectedConfiguration: selectedConfiguration
    };
}

export const selectedConfigurationForBulkCopy = (selectedConfigurationForBulkCopy) => {
    localStorage.setItem('selectedConfigurationForBulkCopy', selectedConfigurationForBulkCopy)
    return {
        type: actionTypes.SELECTED_CONFIGURATION_FOR_BULKCOPY,
        selectedConfigurationForBulkCopy: selectedConfigurationForBulkCopy
    };
}

//AttributeList
export const attributeList = (attributeList) => {
    localStorage.setItem('attributeList', attributeList)
    return {
        type: actionTypes.ATTRIBUTE_LIST,
        attributeList: attributeList
    };
}

export const configFail = (configFail) => {
    localStorage.setItem('configFail', configFail)
    return {
        type: actionTypes.CONFIG_FAIL,
        configFail: configFail
    };
}

export const configuration = () => {
    return dispatch => {
        // console.log("api call")
        const selectedComponent = JSON.parse(localStorage.getItem('selectedComponent'));
        const selectedEnvironment = JSON.parse(localStorage.getItem('selectedEnvironment'));
        // const selectedEnvironment = localStorage.getItem('selectedEnvironment');
        const environments = JSON.parse(localStorage.getItem('environments'));
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem('token');
        const isAdmin=localStorage.getItem('isAdmin');
        if (selectedEnvironment != null && selectedComponent != null) {
            let config = null;
            let url = "configurationGet"
            let postdata = { componentContextCode: selectedComponent.componentContextCode, environmentId: selectedEnvironment.tenantId, token: token, userId: userId }
            axios.post(url, postdata)
                .then(configResponse => {
                    config = configResponse.data.response;
                    // console.log(config);
                    dispatch(selectedConfiguration(config));
                })
                .catch(err => {
                    if(typeof err.response!="object")
                    {
                        dispatch(configFail("Network Error"));
                        console.log(err);
                    }
                    else 
                    {
                        if(err.response.status === 403) {
                        console.log(err.response.data.responseMessage);
                        // setState({ allApps: [] });
                        // dispatch(authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                    }
            }
        });
        }
    }
};

export const attributelist = () => {
    return dispatch => {
      
        const selectedComponent = JSON.parse(localStorage.getItem('selectedComponent'));
        const selectedEnvironment = JSON.parse(localStorage.getItem('selectedEnvironment'));
        const environments = JSON.parse(localStorage.getItem('environments'));
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem('token');
        const isAdmin=localStorage.getItem('isAdmin');
        if (selectedEnvironment != null && selectedComponent != null) {
            let config = null;
            let url = "getContextList"
            let postdata = {
                userId: userId,
                token: token,
                environmentId: selectedEnvironment.tenantId,
            }
            axios.post(url, postdata)
                .then(contextList => {
                    let clist = contextList.data.response[0];
                    dispatch(attributeList(clist.attribute));
                })
                .catch(err => {
                    if(typeof err.response!="object")
                    {
                        // dispatch(configFail("Network Error"));
                        console.log(err);
                    }
                    else 
                    {
                        if(err.response.status === 403) {
                        console.log(err.response.data.responseMessage);
                       
                    }
            }
        });
        }
    }
};
